// Tab type definitions with their required properties
export const TAB_TYPES = {
  gallery: {
    label: 'Gallery',
    defaultProperties: {
      projects: []
    },
    description: 'Affiche la Gallery pour les projets sélectionnés (l\'utilisateur doit avoir les droits sur Gallery pour voir les projets)'
  },
  'gi-ai': {
    label: 'GI AI',
    defaultProperties: {
      clientId: null
    },
    description: 'Affiche le GI AI Report Viewer pour le client configuré'
  },
  weekly: {
    label: 'Weekly',
    defaultProperties: {
      clientSlug: ''
    },
    description: 'Affiche les rapports Weekly du client configuré, sans accès aux autres clients (jail)'
  },
  embed: {
    label: 'Contenu embarqué',
    defaultProperties: {
      src: ''
    },
    description: 'Intègre une page web externe (Tableau, PowerBI, etc.)'
  },
  external: {
    label: 'Lien externe',
    defaultProperties: {
      src: ''
    },
    description: 'Ouvre un lien dans un nouvel onglet'
  }
};

// Fonction utilitaire de slugification
export const slugify = (text) => {
  return (text || '')
    .toString()
    .toLowerCase()
    .normalize('NFD') // Décomposer les caractères accentués
    .replace(/[\u0300-\u036f]/g, '') // Supprimer les accents
    .replace(/\s+/g, '-') // Remplacer les espaces par des tirets
    .replace(/[^\w-]+/g, '') // Supprimer les caractères non alphanumériques
    .replace(/--+/g, '-') // Remplacer les multiples tirets par un seul
    .replace(/^-+/, '') // Supprimer les tirets au début
    .replace(/-+$/, ''); // Supprimer les tirets à la fin
};
